import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/illustrations/warning.png'


const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Luca Education",
      height: "60",
      src: _imports_0,
      title: "Luca Education",
      width: "60"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }, " Bạn muốn dừng làm báo cáo tuần? "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-neutral-500 mt-2" }, " Luca đã lưu báo cáo của những mục tiêu đã được xác nhận kết quả. Bạn có thể quay lại để làm tiếp báo cáo bất cứ lúc nào ")
], -1)
const _hoisted_3 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, " Quay lại "),
      _createElementVNode("button", {
        class: "button-p text-center whitespace-nowrap",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit')))
      }, " Thoát ")
    ])
  ]))
}